import { Modal, message } from 'antd';
import useSceneStore from '../stores/sceneStore';
import useSelectionStore from '../stores/selectionStore';
import { deleteModel as apiDeleteModel } from '../api/models';

// ============================================
// 模型批量操作（参考主流编辑器：Three.js Editor / Blender / Unity）
// - 批量删除：选中多个模型时弹一次确认（显示数量），确认后全部删除并清空选择
// - 单个删除保持原行为（不确认，快速操作）
// ============================================

export function deleteModelsByIds(ids: string[], options?: { force?: boolean }): void {
  const list = ids.filter(Boolean);
  if (list.length === 0) return;

  const run = () => {
    const store = useSceneStore.getState();
    list.forEach((id) => {
      store.removeModel(id);
      apiDeleteModel(id).catch(() => {});
    });
    useSelectionStore.getState().deselectAll();
    message.success(`已删除 ${list.length} 个模型`);
  };

  if (options?.force || list.length <= 1) {
    run();
    return;
  }

  Modal.confirm({
    title: `确认删除所选 ${list.length} 个模型？`,
    content: '删除后将同步移除场景与服务器中的模型，此操作不可逆。',
    okText: '删除',
    okButtonProps: { danger: true },
    cancelText: '取消',
    onOk: () => run(),
  });
}